export function canWriteProductCatalog(canWriteModule: (moduleCode: string) => boolean): boolean {
  return canWriteModule('sales.products') || canWriteModule('products.workspace');
}
